const MAX_FILE_SIZE_MB = 25;
const MAX_FILE_SIZE_BYTES = 1024 * 1024 * MAX_FILE_SIZE_MB;

const Attachments = {
  MAX_FILE_SIZE_BYTES,
  MAX_FILE_SIZE_MB,
};

export default Attachments;
